module.exports = __webpack_public_path__ + "img/icon-about-1.325a783e.png";